import React from 'react';
import {useField} from 'formik';
import {Input} from '../../../../../../../form/form.jsx';

const Name = () => {
  const [field, meta, helpers] = useField('name');

  const isValid = !(meta.error && meta.touched);

  return (
    <Input
      {...field}
      placeholder="ФИО"
      isValid={isValid}
      onChange={helpers.setValue}
    />
  );
};

export default Name;
